import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { usePermission } from '@sb/shared/permission/data-access';
import { ButtonComponent } from '@sb/ui/button';
import { DividerDirective } from '@sb/ui/divider';
import { IconComponent } from '@sb/ui/icon';

import type { EmployeeOverviewData } from '../../../employee-absence-overview.model';
import { TimeOffPartialBalanceItemComponent } from './time-off-partial-balance-item/time-off-partial-balance-item.component';
import type { PartialBalance } from './time-off-partial-balance.model';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'time-off-partial-balance',
  templateUrl: './time-off-partial-balance.component.html',
  imports: [
    CommonModule,
    TranslatePipe,
    ButtonComponent,
    IconComponent,
    TimeOffPartialBalanceItemComponent,
    RouterLink,
    DividerDirective,
  ],
})
export class TimeOffPartialBalanceComponent {
  @Input()
  partial: PartialBalance;

  employee = input.required<EmployeeOverviewData>();

  canAdjustTimeOffBalances = usePermission(() => ({
    permissions: ['Adjust time off balances'],
    userId: this.employee().id,
    departments: this.employee().departments,
  }));

  isActive = false;
}
